import { render, staticRenderFns } from "./AsseverazioniDashboard.vue?vue&type=template&id=25927d4f&"
import script from "./AsseverazioniDashboard.vue?vue&type=script&lang=js&"
export * from "./AsseverazioniDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AsseverazioniDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports